import React from 'react';
import { observer } from 'mobx-react';
import { ProductHistoryLogListTemplate } from 'themes/modules/product/pages';
import { ProductHistoryLogViewStore } from 'modules/product/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(rootStore => new ProductHistoryLogViewStore(rootStore), 'productHistoryLogViewStore')
@observer
class ProductHistoryLogList extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <ProductHistoryLogListTemplate {...this.props} headerCell={[]} />;
	}
}

export default ProductHistoryLogList;



// WEBPACK FOOTER //
// ./src/modules/product/pages/ProductHistoryLogList.jsx